module.exports = __webpack_public_path__ + "img/恐龙蛋翼龙公仔-2.93947c40.jpg";